<div class="row g-0">
    <div class="col-md-2 d-none d-md-block px-2 py-3">
        <div class="row full-height">
            <div class="col-12 map-soon p-3  d-none">
                <div class="heading-5">EXCITING THINGS ARE HAPPENING!</div>
                <div class="paragraph">Agents & Brokers are actively listing top commercial and development properties
                    behind the scenes. </div>
                <div class="underline"></div>
                <div class="heading-5">PUBLIC LAUNCH AS SOON AS 2026!</div>
                <div class="paragraph">Check back to explore the smartest commercial listings in South Africa.</div>
            </div>
            <div class="col-12 mt-1">
                <div class="filter-panel-frame">
                    <div class="filter-panel-title heading-2">Filter Search</div>
                    <div class="filter-panel-scroll">
                        <div *ngFor="let item of searchFilters; trackBy: trackByFilterId" class="filter-row"
                            [class.open]="item.expanded">
                            <div class="filter-row-header">
                                <button type="button" class="filter-row-toggle" [id]="item.id"
                                    (click)="openSearchPanel(item)">
                                    <span class="filter-row-label heading-5">{{item.name}}</span>
                                    <span class="filter-row-sign">{{item.expanded ? '−' : '+'}}</span>
                                </button>
                            </div>
                            <div *ngIf="item.expanded == true" class="filter-row-body">
                                <div *ngIf="item.id == 2" class="sector-list">
                                    <p class="section-intro paragraph">What kind of opportunity are you looking
                                        for?</p>
                                    <div *ngFor="let option of sectorOptions; trackBy: trackBySectorId"
                                        class="sector-item" [class.selected]="selectedSector === option.id">
                                        <label class="sector-check-row">
                                            <input type="radio" name="sector" [checked]="selectedSector === option.id"
                                                (click)="toggleSector(option.id)" />
                                            <span class="sector-label heading-5">{{ option.value }}</span>
                                        </label>
                                        <p class="sector-subtitle paragraph">
                                            <ng-container *ngIf="option.id == 1">A property to use or
                                                improve</ng-container>
                                            <ng-container *ngIf="option.id == 2">A property to develop or
                                                redevelop</ng-container>
                                        </p>
                                        <p class="sector-desc paragraph">
                                            <ng-container *ngIf="option.id == 1">Existing facilities to occupy,
                                                operate or enhance.</ng-container>
                                            <ng-container *ngIf="option.id == 2">Vacant land, or property with
                                                potential for substantial new development.</ng-container>
                                        </p>
                                    </div>
                                </div>
                                <div *ngIf="item.id == 3" class="type-tree">
                                    <div class="type-intro" *ngIf="selectedSector !== 2">
                                        <p class="type-intro-title heading-5">Find the exact property you need</p>
                                        <p class="type-intro-sub paragraph">Select a category and narrow your search
                                            to a specific property type</p>
                                    </div>
                                    <div class="type-intro" *ngIf="selectedSector === 2">
                                        <p class="type-intro-title heading-5">What would you like to develop?</p>
                                        <p class="type-intro-sub paragraph">Choose one or more intended property
                                            types</p>
                                    </div>
                                    <ng-container *ngIf="selectedSector !== 2; else simpleTypeView">
                                        <div *ngFor="let node of advertTypes; trackBy: trackByAdvertTypeId"
                                            class="type-category" [class.open]="node.expanded">
                                            <button type="button" class="type-category-toggle"
                                                (click)="toggleTypeCategory(node)">
                                                <span>{{ node.description }}</span>
                                                <svg class="chevron" viewBox="0 0 24 24" fill="none"
                                                    stroke="currentColor" stroke-width="2.5">
                                                    <polyline points="6 9 12 15 18 9" />
                                                </svg>
                                            </button>
                                            <div *ngIf="node.expanded" class="type-category-body">
                                                <div *ngFor="let subgroup of node.subgroups" class="subgroup">
                                                    <p *ngIf="subgroup.description" class="subgroup-title">
                                                        {{ subgroup.description }}</p>
                                                    <label *ngFor="let leaf of subgroup.items" class="item-row">
                                                        <span>{{ leaf.description }}</span>
                                                        <input type="checkbox" [(ngModel)]="leaf.checked"
                                                            (ngModelChange)="onFilterCheckboxChange()"
                                                            name="typeLeaf-{{leaf.id}}" />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                    <ng-template #simpleTypeView>
                                        <div class="option-flat-list">
                                            <label *ngFor="let option of advertTypes; trackBy: trackByAdvertTypeId"
                                                class="simple-type-row">
                                                <span>{{option.description}}</span>
                                                <input type="checkbox" [(ngModel)]="option.isChecked"
                                                    (ngModelChange)="onFilterCheckboxChange()" [name]="advertTypes"
                                                    #advertTypes="ngModel" />
                                            </label>
                                        </div>
                                    </ng-template>
                                </div>
                                <div *ngIf="item.id == 4" class="price-slider-block">
                                    <div class="slider-wrap">
                                        <div class="range-track" #priceTrack>
                                            <div class="handle-bubble" [style.left.%]="priceMinPct">{{ priceMinLabel
                                                }}</div>
                                            <div class="handle-bubble" [class.is-above]="priceMaxPct >= 99"
                                                [style.left.%]="priceMaxPct">{{ priceMaxLabel }}</div>
                                            <div class="range-fill" [style.left.%]="priceMinPct"
                                                [style.right.%]="100 - priceMaxPct"></div>
                                            <div class="range-handle" [style.left.%]="priceMinPct"
                                                (mousedown)="onPriceHandleDragStart('min', $event)"
                                                (touchstart)="onPriceHandleDragStart('min', $event)"></div>
                                            <div class="range-handle" [style.left.%]="priceMaxPct"
                                                (mousedown)="onPriceHandleDragStart('max', $event)"
                                                (touchstart)="onPriceHandleDragStart('max', $event)"></div>
                                        </div>
                                    </div>
                                    <p class="slide-hint paragraph">Slide to filter</p>
                                </div>
                                <div *ngIf="item.id == 5" class="option-flat-list">
                                    <label *ngFor="let option of standSizeOptions; trackBy: trackByStandSizeId"
                                        class="item-row">
                                        <span>{{option.value}}</span>
                                        <input type="checkbox" [(ngModel)]="option.checked"
                                            (ngModelChange)="onFilterCheckboxChange()" [name]="standSizeOptions"
                                            #standSizeOptions="ngModel" />
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="filter-panel-note" routerLink="/share-in-our-database">
                        <p class="paragraph filter-note-heading"><strong>Can't find exactly what you need?</strong>
                        </p>
                        <ul class="note-steps paragraph">
                            <li>Select <a routerLink="/share-in-our-database" class="filter-note-link">PLACE YOUR
                                    ORDER</a> in the top menu.</li>
                            <li>Tell us what you are looking for.</li>
                            <li>We'll notify you when a match enters the market.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 col-md-10">
        <div class="map-container">
            <div id="pfsMap" [hidden]="!isMapView"></div>
            <div class="property-grid-container" *ngIf="!isMapView">
                <div class="property-grid">
                    <app-property-for-sale-card *ngFor="let advert of propertyAdverts; trackBy: trackByAdvertId"
                        [advert]="advert" layout="grid"></app-property-for-sale-card>
                </div>
            </div>
            <div class="search-block-top">
                <button type="button" class="map-view-button" [class.active]="isMapView" (click)="toggleMapView()">
                    <svg class="map-view-icon" width="36" height="35" viewBox="0 0 36 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M24.0405 27.125H28.2475L34.2576 33.875H1.80307L7.21217 27.125H11.4192V26H6.91166C6.72249 26 6.54435 26.0834 6.43085 26.225L0.120238 34.1C-0.0789199 34.3485 -0.0251037 34.7011 0.24044 34.8875C0.344472 34.9605 0.471005 35 0.601046 35H35.399C35.7309 35 36 34.7482 36 34.4375C36 34.3083 35.9525 34.1831 35.8654 34.0828L29.0289 26.2078C28.9148 26.0763 28.7435 26 28.5625 26H24.0405V27.125Z" fill="currentColor"/>
                        <path d="M18.6641 29.6099C18.0939 30.13 17.1757 30.13 16.6054 29.6099C9.31439 22.9593 5.63477 16.7844 5.63477 11.0614C5.63477 4.95237 11.0073 0 17.6348 0C24.2622 0 29.6348 4.95237 29.6348 11.0614C29.6348 16.7844 25.9551 22.9593 18.6641 29.6099Z" fill="currentColor"/>
                        <circle cx="17.6348" cy="12" r="5" fill="white"/>
                    </svg>
                    <span class="paragraph">Map View</span>
                </button>
                <div class="search-input-wrapper" [class.active]="isMapView">
                    <input type="text" placeholder="Search province, town or suburb..." aria-label="Search"
                        [(ngModel)]="mapSearch" (input)="onSearchInput()" id="searchInput"
                        class="paragraph p-1 search-input" [matAutocomplete]="auto" autocomplete="off">
                    <mat-icon class="search-input-icon">search</mat-icon>
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                        (optionSelected)="onSearchResultSelected($event)">
                        <mat-option *ngFor="let result of searchResults; trackBy: trackBySearchResult" [value]="result.name">
                            <span class="paragraph">{{ result.name }}</span>
                            <span class="paragraph search-type"> — {{ result.type }}</span>
                        </mat-option>
                    </mat-autocomplete>
                </div>
            </div>
            <div class="mobile-filter-bar d-md-none">
                <button type="button" class="mobile-filter-btn full" (click)="openSearchPanel(searchFilters[1])">
                    <span class="paragraph">Property Type</span>
                    <mat-icon>{{ searchFilters[1].expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                </button>
                <div class="mobile-filter-pill-row">
                    <button type="button" class="mobile-filter-btn pill" (click)="openSearchPanel(searchFilters[0])">
                        <span class="paragraph">Property Stage</span>
                        <mat-icon>{{ searchFilters[0].expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </button>
                    <button type="button" class="mobile-filter-btn pill" (click)="openSearchPanel(searchFilters[2])">
                        <span class="paragraph">Price</span>
                        <mat-icon>{{ searchFilters[2].expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </button>
                    <button type="button" class="mobile-filter-btn pill" (click)="openSearchPanel(searchFilters[3])">
                        <span class="paragraph">Size</span>
                        <mat-icon>{{ searchFilters[3].expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </button>
                </div>
                <ng-container *ngFor="let item of searchFilters; trackBy: trackByFilterId">
                    <div *ngIf="item.expanded" class="mobile-filter-panel">
                        <div *ngIf="item.id == 2">
                            <div *ngFor="let option of sectorOptions; trackBy: trackBySectorId" class="remove-row-gap">
                                <label class="radio-container">
                                    <input type="radio" name="sectorMobile" [checked]="selectedSector === option.id"
                                        (click)="toggleSector(option.id)" />
                                    <span class="check-mark-radio"></span>
                                    <strong class="heading-5 coral-text">
                                        {{ option.value }}
                                    </strong>
                                    <div class="sector-text">
                                        <div *ngIf="option.id == 1">
                                            <span class="heading-5">
                                                Property with existing buildings/facilities:
                                            </span>
                                            <span class="paragraph">
                                                ready to be fitted out, occupied, renovated, or expanded upon.
                                            </span>
                                        </div>
                                        <div *ngIf="option.id == 2">
                                            <span class="heading-5">
                                                Land/erven with development potential:
                                            </span>
                                            <span class="paragraph">
                                                generally vacant OR with structures that can be demolished.
                                            </span>
                                        </div>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div *ngIf="item.id == 3">
                            <div class="property-type-block">
                                <div *ngFor="let option of advertTypes; trackBy: trackByAdvertTypeId">
                                    <label class="checkbox-container paragraph mt-1">
                                        <span class="paragraph">
                                            {{option.description}}
                                        </span>
                                        <input type="checkbox" [(ngModel)]="option.isChecked"
                                            (ngModelChange)="onFilterCheckboxChange()" name="advertTypesMobile" />
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="item.id == 4">
                            <div *ngFor="let option of priceOptions; trackBy: trackByPriceId">
                                <label class="checkbox-container paragraph mt-1">
                                    <span class="paragraph">
                                        {{option.value}}
                                    </span>
                                    <input type="checkbox" [(ngModel)]="option.checked"
                                        (ngModelChange)="onFilterCheckboxChange()" name="priceOptionsMobile" />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                        <div *ngIf="item.id == 5">
                            <div *ngFor="let option of standSizeOptions; trackBy: trackByStandSizeId">
                                <label class="checkbox-container paragraph mt-1">
                                    <span class="paragraph">
                                        {{option.value}}
                                    </span>
                                    <input type="checkbox" [(ngModel)]="option.checked"
                                        (ngModelChange)="onFilterCheckboxChange()" name="standSizeOptionsMobile" />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
            <div class="leftTopButtonBlock d-none d-md-flex">
                <div class="oval-orange-total">{{totalProperties}}</div>
                <div id="breadcrumb" *ngIf="breadcrumbLevels.length" class="breadcrumb">
                    <ng-container *ngFor="let level of breadcrumbLevels; trackBy: trackByBreadcrumbLevel; let i = index">
                        <span class="breadcrumb-item" [ngClass]="{ active: i === breadcrumbLevels.length - 1 }"
                            (click)="onBreadcrumbClick(level)">
                            {{ level.label }}
                        </span>
                        <span *ngIf="i < breadcrumbLevels.length - 1" class="breadcrumb-separator"> > </span>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
